<template>
	<div class="inspectionAccountExpand">
		<data-list
			:data="scope.row.children"
			:columns="columns"
			:isShowHeader="false"
			:table-style="{ name: 'mixture' }"
		></data-list>
	</div>
</template>

<script>
export default {
	name: 'inspectionAccountExpand',
	props: ['scope'],
	data() {
		return {
			columns: [
				{
					label: '',
					width: 60,
					formartAmout: false,
					bind: () => '',
				},
				{
					label: '巡检账号',
					formartAmout: false,
					bind: () => '',
				},
				{
					label: '巡检人',
					formartAmout: false,
					bind: () => '',
				},
				{
					label: '巡检客户',
					bind: 'customerName',
				},
				{
					label: '巡检添加时间',
					bind: 'createTime',
				},
				{
					label: '添加人',
					formartAmout: false,
					bind: () => '',
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					width: 200,
					formartAmout: false,
					bind: () => [],
				},
			],
		};
	},
};
</script>

<style lang="scss" scoped>
.inspectionAccountExpand {
}
</style>
